export type CurrencyProps = 'BRL' | 'USD' | 'EUR' | 'CAD'

export const normalizeCurrencyInput = (value: string, forceNegative = false) => {
  const digits = value.replace(/\D/g, '')

  if (!digits) return !forceNegative && value.includes('-') ? '-' : ''

  const isNegative = forceNegative || value.includes('-')

  return currencyMask(`${isNegative ? '-' : ''}${digits}`)
}

export function currencyMask(value?: string | number, currencyType?: CurrencyProps) {
  let isNegative = false

  if (typeof value === 'number') {
    isNegative = value < 0
    value = Math.abs(value).toFixed(2)
  }

  if (value) {
    if (typeof value === 'string') {
      const trimmed = value.trim()

      if (trimmed.startsWith('-') || trimmed.endsWith('-')) {
        isNegative = true
      }

      value = value.replace(/\D/g, '')
    }

    if (value.length > 2) {
      value = value.replace(/^0+/, '')
    }

    value = value.padStart(3, '0')

    const absoluteNumber = Number(value) / 100
    const signedNumber = isNegative ? -absoluteNumber : absoluteNumber

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: currencyType ?? 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(signedNumber)
  }

  return ''
}
